import { Card, Form, Col, HelperText } from '@deere/ux.uxframe-react'
import { DAYS_OF_THE_WEEK, BUSSINESS_ROLES, SRO_ROLES, SELECT_START_DATE, DELINQUENT_REM_HELPTEXT, INIT_NOTIFICATION_QUESTION } from '../../utils/surveyLiterals'
import { useState, useEffect } from 'react'
import { Typography } from '@mui/material';
import { CURRENT_ENV } from '../../utils/constEnvVariables';
    
export default function RemainderSettings({ campaign, setCampaign, remNotificationSubj, initNotificationSubj, loading, setFrom, setTo, setCc, setBackupContact, lblCompanyName }) {

    const [checkSelections, setCheckSelections] = useState([]);
    const [backupContactSelection, setBackupContactSelection ]= useState(true);
    const [labelNoPrimaryContact, setLabelNoPrimaryContact] = useState("No Contact");
    const [selectedDefaultBackupContactSelect,setSelectedDefaultBackupContactSelect] = useState(0);

    useEffect(()=> {
        const copyCbxs = [...SRO_ROLES.sort((a, b) => (a.description.toUpperCase() > b.description.toUpperCase()) ? 1 : -1)];
        copyCbxs.forEach(cb => {
            if(cb.checked){
                cb.checked = false
            }
        });
        setCheckSelections(copyCbxs);
    },[])

    const handleChangeFrom = e => {
        setFrom(e.target.value);
    }

    const handleChangeTo = e => {
        setTo(e.target.value); 
        setBackupContactSelection(false)
        setSelectedDefaultBackupContactSelect(0)
        setLabelNoPrimaryContact("If there is no "+ e.target.options[e.target.selectedIndex].text+" contact, then send to:" ) 
    }

    const handleChangeBackupContact = e => { 
        setBackupContact(e.target.value); 
        setSelectedDefaultBackupContactSelect(e.target.value); 
         
    }

    const handleChangeCc = (position) => {
        const updatedCheckedState = checkSelections.map((item, index) => {
            if(index === position){
                item.checked = !item.checked
                return item
            }
            return item
        }
        );
        setCheckSelections(updatedCheckedState)
      setCc(updatedCheckedState.map(({description, checked}) => { if(checked) return description; else return '';}))
    }

    const CheckBoxes = ({ checkSelections }) => (
        checkSelections.map((check, index) =>
            <Form.Check
                inline id={check.id} key={index} disabled={loading} label={check.description} size='sm'
                value={check.id} className={'ml-2'} onChange={() => handleChangeCc(index)} checked={check.checked}/>
        )
    )
    const getContactList=(withBackupContact)=>{
        var backupContacts = [...BUSSINESS_ROLES]
          backupContacts= backupContacts.sort((a, b) => (a.description.toUpperCase() > b.description.toUpperCase()) ? 1 : -1)

        if(withBackupContact ){
                const noneContact={id:  0 ,  description:"None"}  
                backupContacts.unshift(noneContact)
        } 
        
       return backupContacts.map(opt => <option key={opt.code} value={opt.id}>{opt.description}</option>)  
    }

    const parseDateAcrossTimeZones = (dateString) => {
        const parts = dateString.split('-');
        const year = parseInt(parts[0], 10);
        const month = parseInt(parts[1], 10) - 1;
        const day = parseInt(parts[2], 10);
        let parsedDate =  new Date(Date.UTC(year, month, day));
        const utcYear = parsedDate.getUTCFullYear();
        const utcMonth = parsedDate.getUTCMonth();
        const utcDate = parsedDate.getUTCDate();
        const utcDateObject = new Date(utcYear, utcMonth, utcDate);
        return utcDateObject;
    };

    /* show reminder dates */
    let reminderDates = [];
    let initialNotification = ""
    if(campaign.startDate){
        initialNotification = parseDateAcrossTimeZones(campaign.startDate);
        initialNotification = ((Number(initialNotification.getMonth()) + 1) + "/" + initialNotification.getDate() + "/" + initialNotification.getFullYear());
        let startDate= parseDateAcrossTimeZones(campaign.startDate);
        let daysUntilFirstRem = Number(campaign.notificationConfig.daysFirstRem);
        let dateAfter_DaysUntilFirstRem = new Date(startDate.setDate(startDate.getDate() + daysUntilFirstRem));
        let dateAfter_DaysUntilFirstRem_Day = dateAfter_DaysUntilFirstRem.getDay();
        let daySelected = DAYS_OF_THE_WEEK.indexOf(campaign.notificationConfig.remainderDay)+1;
        let dayDifference = 0;
        if(daySelected > dateAfter_DaysUntilFirstRem_Day){
            dayDifference = daySelected - dateAfter_DaysUntilFirstRem_Day;
        }else{
            dayDifference = 7 - (dateAfter_DaysUntilFirstRem_Day - daySelected);
        }
        let firstRem = dateAfter_DaysUntilFirstRem;
        firstRem = new Date(firstRem.setDate(firstRem.getDate() + dayDifference));

        let endDate = new Date(campaign.endDate);
        if(!campaign.endDate || endDate.getTime() > firstRem.getTime()){
            reminderDates.push((Number(firstRem.getMonth()) + 1) + "/" +  firstRem.getDate() + "/" + firstRem.getFullYear());
            let noOfReminders = Number(campaign.notificationConfig.numberRemainders);
            let temp = new Date(firstRem);
            for(let i=1; i<noOfReminders; i++){
                temp = new Date(temp.setDate(temp.getDate() + 7));
                if(!campaign.endDate || endDate.getTime() > temp.getTime()){
                    reminderDates.push((Number(temp.getMonth()) + 1) + "/" + temp.getDate() + "/" + temp.getFullYear());
                }
                else{
                    break;
                }
            }
        }
    }

    return (<Card>
        <Card.Body>
            <Typography className={'mt-2 mb-3'} size='2x1' fontWeight={"semibold"} variant={"h2"}>{"Reminder Settings"}</Typography>
            <Form.Row>
                <Form.Group as={Col}>
                    <Form.Label className="uxf-label">Reminder Day Of The Week</Form.Label>
                    <Form.Control required as="select" className="custom-select" disabled={loading || campaign.isOpenEndedCampaign}
                        onChange={e => setCampaign({ ...campaign, notificationConfig: { ...campaign.notificationConfig, remainderDay: e.target.value } })}
                        value={campaign.notificationConfig.remainderDay}>
                        <option value=''>Select</option>
                        {DAYS_OF_THE_WEEK.map(opt => <option key={opt} value={opt}>{opt}</option>)}
                    </Form.Control>
                </Form.Group>
                <Form.Group as={Col}>
                    <Form.Label className="uxf-label">Number Of The Reminders</Form.Label>
                    <Form.Control type="number" name='' required disabled={loading || campaign.isOpenEndedCampaign}
                        onChange={e => setCampaign({ ...campaign, notificationConfig: { ...campaign.notificationConfig, numberRemainders: e.target.value } })}
                        value={campaign.notificationConfig.numberRemainders} />
                </Form.Group>
            </Form.Row>
            <Form.Row>
                <Form.Group as={Col}>
                    <Form.Label className="uxf-label">Days Until First Reminder</Form.Label>
                    <Form.Control type="number" name='' required disabled={loading || campaign.isOpenEndedCampaign}
                        onChange={e => setCampaign({ ...campaign, notificationConfig: { ...campaign.notificationConfig, daysFirstRem: e.target.value } })}
                        value={campaign.notificationConfig.daysFirstRem} />
                </Form.Group>
                <Form.Group as={Col}>
                    <Form.Label className="uxf-label">Email Enabled</Form.Label>
                    <br />
                    <Form.Check required type="radio" value='true' inline label='Yes' name="emailEnabled" disabled={loading}
                        onChange={e => setCampaign({ ...campaign, notificationConfig: { ...campaign.notificationConfig, emailEnabled: e.target.value === 'true' ? true : false } })}
                        checked={campaign.notificationConfig.emailEnabled} />
                    <Form.Check required type="radio" value='false' inline label='No' name="emailEnabled" disabled={loading}
                        onChange={e => setCampaign({ ...campaign, notificationConfig: { ...campaign.notificationConfig, emailEnabled: e.target.value === 'true' ? true : false } })}
                        checked={!campaign.notificationConfig.emailEnabled} />
                </Form.Group>
            </Form.Row>
            <Form.Row>
                <Form.Group as={Col}>
                    <Form.Label className="uxf-label">  Initial Notification: </Form.Label>
                        {campaign.isOpenEndedCampaign
                            ? <div>
                                <Form.Label className="ml-2">{INIT_NOTIFICATION_QUESTION}</Form.Label>
                                <Form.Check type="radio" value='true' inline label='Yes' name="sendInitialNotification" className="ml-2" disabled={loading}
                                    onChange={e => setCampaign({ ...campaign, notificationConfig: { ...campaign.notificationConfig, sendInitialNotification: e.target.value === 'true' } })}
                                    checked={campaign.notificationConfig.sendInitialNotification} />
                                <Form.Check type="radio" value='false' inline label='No' name="sendInitialNotification" disabled={loading}
                                    onChange={e => setCampaign({ ...campaign, notificationConfig: { ...campaign.notificationConfig, sendInitialNotification: e.target.value === 'true' } })}
                                    checked={!campaign.notificationConfig.sendInitialNotification} />
                              </div>
                            : <ul style={{ marginBottom: "0" }}>{campaign.startDate ? initialNotification : SELECT_START_DATE}</ul>}
                </Form.Group>
                <Form.Group as={Col}>
                    <Form.Label className="uxf-label">  Reminder Dates: </Form.Label>
                    {reminderDates.map((date, index)=>
                        <ul style={{ marginBottom: "0" }}>{campaign.startDate?date: ''}</ul>
                    )}
                </Form.Group>
            </Form.Row>
            <Form.Row>
                <Form.Group as={Col} className="mb-0">
                    <Form.Label className="uxf-label">Delinquent Reminders</Form.Label>
                    <br/>
                    <Form.Check required type="radio" value={true} inline label='Yes' name="delinquentEnabled" disabled={loading || campaign.isOpenEndedCampaign}
                        onChange={e => setCampaign({ ...campaign, notificationConfig: { ...campaign.notificationConfig, delinquentEnabled: e.target.value === 'true' } })}
                        checked={campaign.notificationConfig.delinquentEnabled} />
                    <Form.Check required type="radio" value={false} inline label='No' name="delinquentEnabled" disabled={loading || campaign.isOpenEndedCampaign}
                        onChange={e => setCampaign({ ...campaign, notificationConfig: { ...campaign.notificationConfig, delinquentEnabled: e.target.value === 'true', delinquentPrefix : e.target.value === 'false' ? "" : campaign.notificationConfig.delinquentPrefix  } })}
                        checked={!campaign.notificationConfig.delinquentEnabled} />
                </Form.Group>
                <Form.Group as={Col} className="mb-0">
                    <Form.Label className="uxf-label">Subject-Prefix for delinquent reminders</Form.Label>
                    <Form.Control required disabled={loading || campaign.isOpenEndedCampaign || !campaign.notificationConfig.delinquentEnabled} 
                        value={campaign.notificationConfig.delinquentPrefix}
                        onChange={e => setCampaign({ ...campaign, notificationConfig: { ...campaign.notificationConfig, delinquentPrefix: e.target.value } })} />
                </Form.Group>
                <HelperText className="ml-2 mb-2">{DELINQUENT_REM_HELPTEXT}</HelperText>
            </Form.Row>
            <Form.Row>
                <Form.Group as={Col}>
                    <Form.Label className="uxf-label">From</Form.Label>
                    <Form.Control required placeholder="Email" type="email" disabled={loading} onChange={handleChangeFrom} />
                </Form.Group>
            </Form.Row>
            { (!campaign.isNonDeere && !campaign.isOpenEndedCampaign) && <>    {/* Do not show TO/CC if Non-Deere or if it is an open ended campaign */}
            <Form.Row>
                <Form.Group as={Col}>
                    <Form.Label className="uxf-label">To</Form.Label>
                    <Form.Control required as="select" className="custom-select"
                        name='business-role'
                        disabled={loading}
                        onChange={handleChangeTo}>
                        <option value='' key={-1}>Select</option>
                        { getContactList(false)}  
                    </Form.Control>
                </Form.Group>
            </Form.Row>
            <Form.Row>
                <Form.Group as={Col}>
                    <Form.Label className="uxf-label"
                     name="lBackupContact"
                     id="lBackupContact"
                    > {labelNoPrimaryContact}</Form.Label> 
                    <Form.Control as="select" className="custom-select"
                          name="backupContact"
                          id="backupContact"
                          disabled = {(backupContactSelection||loading)}
                          value={selectedDefaultBackupContactSelect}
                           
                          onChange={handleChangeBackupContact}> 
                          { getContactList(true)}             
                    </Form.Control>
                </Form.Group> 
            </Form.Row>
            <Form.Row>
                <Form.Group as={Col}>
                    <Form.Label className="uxf-label">Cc</Form.Label>
                    <Form.Row>
                        <CheckBoxes checkSelections={checkSelections} />
                    </Form.Row>
                </Form.Group>
            </Form.Row>
            </>}
            <Form.Row>
                <Form.Group as={Col}>
                    <Form.Label className="uxf-label">Initial Notification Subject</Form.Label>
                    <Form.Control required onChange={e => setCampaign({ ...campaign, notificationConfig: { ...campaign.notificationConfig, initNotificationSubj: e.target.value } })}
                        value={`${lblCompanyName} ${initNotificationSubj} Request - ACTION REQUIRED`} disabled />
                </Form.Group>
            </Form.Row>
            <Form.Row>
                <Form.Group as={Col}>
                    <Form.Label className="uxf-label">Reminder Notification Subject</Form.Label>
                    <Form.Control type="text" name='' required onChange={e => setCampaign({ ...campaign, notificationConfig: { ...campaign.notificationConfig, remNotificationSubj: e.target.value } })}
                        value={`REMINDER - ${lblCompanyName} ${remNotificationSubj} Request - ACTION REQUIRED`} disabled />
                </Form.Group>
            </Form.Row>
        </Card.Body>
    </Card>)
}